import ChargerModule from '../../../components/chargerModule';
import BulkUploadCard from './components/BulkUploadCard/BulkUploadCard';
import TypeOfChargeInfo from './components/TypeOfChargeInfo/TypeOfChargeInfo';
import UploadHistory from './components/UploadHistory/UploadHistory';
import { BULK_UPLOAD_CARDS } from './constants';
import './TypeOfCharge.scss';

const TypeOfCharge = () => {
  return (
    <ChargerModule
      headerInfo={{
        title: 'Cargue Masivo',
        subtitle: '',
        titleRoute: '/bulk-upload/type-of-charge'
      }}
      infoSideBar={{ position: 'bulkUpload' }}
    >
      <section className="typeOfCharge">
        <TypeOfChargeInfo
          title={'Tipo de cargue masivo'}
          description={
            <>
              Gestiona información de forma masiva con plantillas de <strong>.xlsx</strong>
            </>
          }
        />
        <section className="typeOfChargeCards">
          {BULK_UPLOAD_CARDS.map((card, index) => (
            <BulkUploadCard key={`typeOfChargeCards-${index}`} {...card} />
          ))}
        </section>
        <section className="typeOfChargeHistory">
          <UploadHistory />
        </section>
      </section>
    </ChargerModule>
  );
};

export default TypeOfCharge;
